/*
 * Copyright Elasticsearch B.V. and/or licensed to Elasticsearch B.V. under one
 * or more contributor license agreements. Licensed under the Elastic License
 * 2.0; you may not use this file except in compliance with the Elastic License
 * 2.0.
 */

// DO NOT MODIFY THIS FILE BY HAND. IT IS GENERATED BY
// `yarn workspace @elastic/esql-definitions generate` FROM
// `elasticsearch/promql/x-pack-esql/definition/functions/clamp_max.json`.

import type { PromqlFunctionDefinition } from '../../definition_types';

/**
 * Clamps the sample values of all elements to have an upper limit of max.
 *
 * @example
 * clamp_max(http_requests_total, 100)
 */
const definition: PromqlFunctionDefinition = {
  type: 'value_transformation',
  name: 'clamp_max',
  signatures: [
    {
      params: [
        {
          name: 'v',
          type: 'instant_vector',
          optional: false,
          description: 'Instant vector input.',
        },
        {
          name: 'max',
          type: 'scalar',
          optional: false,
          description: 'Maximum value.',
        },
      ],
      variadic: false,
      returnType: 'instant_vector',
    },
  ],
  snapshotOnly: false,
};

export default definition;
